module.exports = __webpack_public_path__ + "static/media/DELIV.54971949.svg";